module.exports = ".center {\n  margin: 50px auto;\n  max-width: 600px; }\n\nbutton {\n  float: right;\n  margin: 5px; }\n\nimg {\n  margin: 10px; }\n\nbutton.cancel {\n  background-color: #44697D;\n  color: whitesmoke;\n  font-weight: bold;\n  border: 1px solid #44697D; }\n\nbutton:hover.cancel {\n  background-color: #7D9AAA;\n  color: whitesmoke;\n  font-weight: bold;\n  border: 1px solid #7D9AAA; }\n\n.list-group-item {\n  vertical-align: middle; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/apps/apps.scss
// module id = ./src/app/pages/apps/apps.scss
// module chunks = main